var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('MediaPlayer',{ref:"mediaPlayer",attrs:{"videoIsPlaying":_vm.videoIsPlaying,"comments":_vm.comments,"currentTimestamp":this.currentTimestamp,"windowWidth":_vm.windowWidth}})],1),_vm._v(" "),_c('footer',[_vm._v("\n    Video courtesy of Big Buck Bunny "),_c('br'),_vm._v("\n    "+_vm._s(_vm.year.year)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98f7d4b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 